import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template115: Trafalgar, National Gallery, Piccadilly, Leicester (Page4 guia-londres)
// Todo desde backend: page.texts[0]=header, page.sections[0..3]=trafalgar, nationalGallery, piccadilly, leicester
const Template115 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;

	const getImageSrc = (id) => {
		if (page.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const trafalgar = sections[0];
	const nationalGallery = sections[1];
	const piccadilly = sections[2];
	const leicester = sections[3];

	const trafalgarImage = getImageSrc("trafalgar");
	const nationalGalleryImage = getImageSrc("national-gallery");
	const piccadillyImage =
		getImageSrc(piccadilly?.imageId) ?? getImageSrc("picadilly");
	const leicesterImage = getImageSrc("leicester");

	const actualHeaderColor = headerBackgroundColor || "#de5624";
	const contentColor = textColor || "#444";

	const h3Style = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginTop: 8,
		marginBottom: 4,
		margin: 0,
	};
	const pStyle = {
		fontSize: 13,
		color: contentColor,
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		margin: 0,
	};

	// Para la caja amarilla: primera frase en negrita (hasta ". ")
	const getFreeTourBoxContent = (text) => {
		if (!text) return { bold: "", rest: "" };
		const idx = text.indexOf(". ");
		if (idx < 0) return { bold: text, rest: "" };
		return { bold: text.slice(0, idx + 1), rest: text.slice(idx + 2) };
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 9999,
					}}
				>
					{headerText}
					{logoImage && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					flexDirection: "column",
					height: "100%",
				}}
			>
				<Box sx={{ padding: "10px 12px", flex: 1 }}>
					<Box
						sx={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: "16px",
						}}
					>
						{/* Trafalgar Square */}
						{(trafalgar?.title || trafalgar?.body) && (
							<Box
								data-block-id="text-1"
								sx={{
									display: "flex",
									gap: "20px",
									alignItems: "flex-start",
								}}
							>
								{trafalgarImage && (
									<img
										src={trafalgarImage}
										alt={trafalgar?.title}
										style={{
											width: "40%",
											height: 110,
											borderRadius: 12,
											objectFit: "cover",
										}}
									/>
								)}
								<Box sx={{ width: "60%" }}>
									{trafalgar?.title && (
										<Box component="h3" sx={h3Style}>
											{trafalgar.title}
										</Box>
									)}
									{trafalgar?.body && (
										<Box component="p" sx={pStyle}>
											{trafalgar.body}
										</Box>
									)}
								</Box>
							</Box>
						)}

						{/* National Gallery */}
						{(nationalGallery?.title || nationalGallery?.body) && (
							<Box
								data-block-id="text-2"
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: "16px",
									position: "relative",
								}}
							>
								<Box
									sx={{
										display: "flex",
										gap: "20px",
										alignItems: "flex-start",
										position: "relative",
									}}
								>
									{nationalGalleryImage && (
										<img
											src={nationalGalleryImage}
											alt={nationalGallery?.title}
											style={{
												width: "40%",
												height: 110,
												borderRadius: 12,
												objectFit: "cover",
											}}
										/>
									)}
									<Box sx={{ position: "absolute", top: 0, left: "34%" }}>
										{nationalGallery?.sabiasQue?.[0] && (
											<SabiasQue
												icono={nationalGallery.sabiasQue[0].icono}
												texto={nationalGallery.sabiasQue[0].texto}
											/>
										)}
									</Box>
									<Box sx={{ width: "60%", position: "relative" }}>
										{nationalGallery?.title && (
											<Box component="h3" sx={h3Style}>
												{nationalGallery.title}
											</Box>
										)}
										{nationalGallery?.body && (
											<Box component="p" sx={pStyle}>
												{nationalGallery.body}
											</Box>
										)}
									</Box>
								</Box>

								{/* Caja amarilla + sticker + free tour (después de National Gallery) */}
								{nationalGallery?.freeTourBox && (
									<Box
										sx={{
											padding: "10px 12px",
											position: "relative",
											display: "flex",
											flexDirection: "row",
											gap: "20px",
										}}
									>
										<Box sx={{ width: "40%" }}>
											{nationalGallery.freeTourBox.stickerCanvasId &&
												getCanvasImageUrl(
													nationalGallery.freeTourBox.stickerCanvasId,
												) && (
													<img
														src={getCanvasImageUrl(
															nationalGallery.freeTourBox.stickerCanvasId,
														)}
														alt=""
														style={{
															width: 105,
															position: "absolute",
															top: 50,
															left: -20,
															zIndex: 999,
														}}
													/>
												)}
											{(nationalGallery.freeTourBox.textShort ||
												nationalGallery.freeTourBox.textLong) && (
												<Box
													sx={{
														position: "absolute",
														top: -20,
														left: -8,
														width: isSmallScreen ? 86 : 120,
														backgroundColor: "#fff8db",
														border: "2px solid #f5c400",
														borderRadius: "16px 16px 16px 0px",
														padding: "10px 12px",
														fontSize: 11,
														color: contentColor,
														boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
														zIndex: 999,
													}}
												>
													{(() => {
														const text = isSmallScreen
															? nationalGallery.freeTourBox.textShort
															: nationalGallery.freeTourBox.textLong;
														const { bold, rest } = getFreeTourBoxContent(text);
														return (
															<>
																{bold && <strong>{bold}</strong>}
																{rest && ` ${rest}`}
															</>
														);
													})()}
												</Box>
											)}
										</Box>
										{nationalGallery?.freeTour &&
											(nationalGallery.freeTour.title ||
												nationalGallery.freeTour.body ||
												nationalGallery.freeTour.url) && (
												<Box
													sx={{
														backgroundColor: "#f4e4df",
														border: "3px solid #ec7447",
														borderRadius: "12px",
														padding: "8px 14px",
														fontSize: "12px",
														color: contentColor,
														textAlign: "center",
													}}
												>
													{nationalGallery.freeTour.title && (
														<strong>{nationalGallery.freeTour.title}</strong>
													)}{" "}
													{nationalGallery.freeTour.body}{" "}
													{nationalGallery.freeTour.url &&
														nationalGallery.freeTour.linkText && (
															<a
																href={nationalGallery.freeTour.url}
																target="_blank"
																rel="noopener noreferrer"
																style={{
																	display: "inline-block",
																	marginTop: 8,
																	color: "#ec7447",
																	textDecoration: "underline",
																	fontWeight: 700,
																}}
															>
																{nationalGallery.freeTour.linkText}
															</a>
														)}
												</Box>
											)}
									</Box>
								)}
							</Box>
						)}

						{/* Piccadilly Circus */}
						{(piccadilly?.title || piccadilly?.body) && (
							<Box
								data-block-id="text-3"
								sx={{
									display: "flex",
									gap: "20px",
									alignItems: "flex-start",
									position: "relative",
								}}
							>
								<Box sx={{ width: "40%", flexShrink: 0 }}>
									{piccadillyImage && (
										<img
											src={piccadillyImage}
											alt={piccadilly?.title ?? "Piccadilly Circus"}
											style={{
												width: "100%",
												height: 110,
												borderRadius: 12,
												objectFit: "cover",
												display: "block",
											}}
										/>
									)}
								</Box>
								<Box sx={{ position: "absolute", top: 0, left: "34%" }}>
									{piccadilly?.sabiasQue?.[0] && (
										<SabiasQue
											icono={piccadilly.sabiasQue[0].icono}
											texto={piccadilly.sabiasQue[0].texto}
										/>
									)}
								</Box>
								<Box sx={{ width: "60%", position: "relative" }}>
									{piccadilly?.title && (
										<Box component="h3" sx={h3Style}>
											{piccadilly.title}
										</Box>
									)}
									{piccadilly?.body && (
										<Box component="p" sx={pStyle}>
											{piccadilly.body}
										</Box>
									)}
								</Box>
							</Box>
						)}
					</Box>
				</Box>

				{/* Leicester Square (layout bottomImage) */}
				{(leicester?.title || leicester?.body) && (
					<Box data-block-id="text-4" sx={{ position: "relative" }}>
						<Box sx={{ width: "100%" }}>
							<Box sx={{ padding: "10px 12px", position: "relative" }}>
								{leicester?.title && (
									<Box
										component="h3"
										sx={{
											...h3Style,
											flex: 1,
										}}
									>
										{leicester.title}
									</Box>
								)}
								{leicester?.body && (
									<Box component="p" sx={{ ...pStyle, flex: 1 }}>
										{leicester.body}
									</Box>
								)}
								<Box sx={{ position: "absolute", top: 0, left: "50%" }}>
									{leicester?.sabiasQue?.[0] && (
										<SabiasQue
											icono={leicester.sabiasQue[0].icono}
											texto={leicester.sabiasQue[0].texto}
										/>
									)}
								</Box>
							</Box>
							{leicester?.stickerCanvasId &&
								getCanvasImageUrl(leicester.stickerCanvasId) && (
									<img
										src={getCanvasImageUrl(leicester.stickerCanvasId)}
										alt=""
										style={{
											width: 100,
											position: "absolute",
											bottom: 20,
											right: 20,
										}}
									/>
								)}
						</Box>
						{leicesterImage && (
							<img
								src={leicesterImage}
								alt={leicester?.title}
								style={{
									width: "100%",
									height: 120,
									objectFit: "cover",
								}}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template115.thumbnail = "/images/template-1.png";

export default Template115;
